export enum FilterName {
    Status = "Status",
    Period = "Period",
    Platforms = "Platforms"
}